/* ============================================================
   ESCORPIÓN — Carrito lateral (oct 2026)

   Por qué se llama <cart-notification>:
   `assets/product-form.js` (Sense/Dawn) busca `<cart-notification>` o
   `<cart-drawer>` en el DOM. Si no encuentra ninguno hace
   `window.location = routes.cart_url` y rompe el flujo de añadir varias
   tallas seguidas. Este elemento implementa la interfaz que espera
   (getSectionsToRender / setActiveElement / renderContents), así que no
   hay que tocar product-form.js ni los scripts de parches y personalización.

   Antes era una tarjeta que se cerraba sola; ahora es un panel a la derecha:
   - Al agregar: "Agregado al carrito" + lo agregado + todo el carrito.
   - Icono del carrito del header: "Tu carrito".
   - Quitar una camiseta quita también sus parches y su personalización.
   - No se cierra solo: X, clic fuera o Escape.
   ============================================================ */

(function () {
  if (customElements.get('cart-notification')) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // Mismo formato que el resto del sitio: "$100.000"
  function formatMoney(cents) { return '$' + Math.round(Number(cents || 0) / 100).toLocaleString('es-CO'); }
  function thumbUrl(url) { if (!url) return ''; return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=160'; }
  function cartRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function esComplemento(it) { return it.product_type === 'Parche' || it.product_type === 'Servicio'; }
  function etiqueta(it) { return it.product_title + ' — Talla ' + it.variant_title; }

  /* Propiedades visibles: sin las internas (_foo) ni las vacías. */
  function visibleProperties(properties) {
    var out = [];
    if (!properties) return out;
    Object.keys(properties).forEach(function (key) {
      if (key.charAt(0) === '_') return;
      var v = properties[key];
      if (v === null || v === undefined || String(v).trim() === '') return;
      out.push({ key: key, value: String(v) });
    });
    return out;
  }

  function itemMarkup(item, conQuitar) {
    var image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Por defecto' && !esComplemento(item)) {
      meta.push('<span>Talla ' + escapeHtml(item.variant_title) + '</span>');
    }
    if (item.quantity > 1) meta.push('<span>× ' + escapeHtml(item.quantity) + '</span>');
    var props = visibleProperties(item.properties)
      .filter(function (p) { return p.key !== 'Para la camiseta'; })
      .map(function (p) { return '<li>' + escapeHtml(p.key) + ': ' + escapeHtml(p.value) + '</li>'; }).join('');
    var price = formatMoney(typeof item.final_line_price === 'number' ? item.final_line_price : item.final_price);
    return (
      '<div class="esc-cajon__item' + (esComplemento(item) ? ' esc-cajon__item--extra' : '') + '">' +
      (image ? '<div class="esc-cajon__thumb"><img src="' + escapeHtml(thumbUrl(image)) + '" alt="" loading="lazy" width="56" height="70"></div>'
             : '<div class="esc-cajon__thumb esc-cajon__thumb--extra" aria-hidden="true">+</div>') +
      '<div class="esc-cajon__info">' +
      '<p class="esc-cajon__nombre">' + escapeHtml(item.product_type === 'Servicio' ? 'Nombre y número' : (item.product_title || item.title || '')) + '</p>' +
      (meta.length ? '<p class="esc-cajon__meta">' + meta.join(' · ') + '</p>' : '') +
      (props ? '<ul class="esc-cajon__props">' + props + '</ul>' : '') +
      '</div>' +
      '<div class="esc-cajon__der">' +
      '<p class="esc-cajon__precio">' + escapeHtml(price) + '</p>' +
      (conQuitar ? '<button type="button" class="esc-cajon__quitar" data-esc-cajon-quitar="' + escapeHtml(item.key) + '" aria-label="Quitar ' + escapeHtml(item.product_title) + '">Quitar</button>' : '') +
      '</div></div>'
    );
  }

  /* add.js devuelve el ítem suelto (uno) o { items: [...] } (varios). */
  function itemsFrom(response) {
    if (!response) return [];
    if (Array.isArray(response.items)) return response.items;
    if (response.id) return [response];
    return [];
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Contador del header (.esc-hdr__cart-count y el del menú móvil). */
  function paintCount(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    document.querySelectorAll('[data-esc-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', 'hidden');
    });
    document.querySelectorAll('[data-esc-cart-label]').forEach(function (el) { el.textContent = count > 0 ? 'Carrito (' + count + ')' : 'Carrito'; });
    var link = document.querySelector('.esc-hdr__icon--cart');
    if (link) link.setAttribute('aria-label', 'Carrito (' + count + ' items)');
  }
  function refreshCount() { return fetchCart().then(function (c) { paintCount(c.item_count); return c; }).catch(function () {}); }

  class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
      this.onKeyup = this.handleKeyup.bind(this);
    }

    connectedCallback() {
      if (this.booted) return;
      this.booted = true;
      this.panel = this.querySelector('.esc-cajon__panel');
      this.body = this.querySelector('[data-esc-toast-body]');
      this.lista = this.querySelector('[data-esc-cajon-lista]');
      this.titulo = this.querySelector('[data-esc-cajon-titulo]');
      this.check = this.querySelector('[data-esc-cajon-check]');
      this.h = this.querySelector('[data-esc-cajon-h]');
      this.vacio = this.querySelector('[data-esc-cajon-vacio]');
      this.countEl = this.querySelector('[data-esc-toast-count]');
      this.pagar = this.querySelector('[data-esc-cajon-pagar]');
      var self = this;

      this.querySelectorAll('[data-esc-toast-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });

      // Quitar una línea (y sus complementos si es una camiseta)
      this.lista.addEventListener('click', function (e) {
        var b = e.target.closest('[data-esc-cajon-quitar]');
        if (b) self.quitar(b.getAttribute('data-esc-cajon-quitar'), b);
      });

      // Los parches y la personalización se añaden por su cuenta y avisan por evento.
      document.addEventListener('cart:refresh', function () {
        if (self.classList.contains('is-open')) self.pintarCarrito(); else refreshCount();
      });

      // El icono del carrito del header abre este panel (salvo en /cart, donde ya se ve todo)
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a.esc-hdr__icon--cart, a[href="/cart"].esc-hdr__icon');
        if (!a || /\/cart\/?$/.test(window.location.pathname) || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        self.activeElement = a;
        self.abrir('carrito');
      });
    }

    /* --- interfaz que espera product-form.js --- */
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(element) { this.activeElement = element; }
    renderContents(parsedState) {
      var items = itemsFrom(parsedState);
      if (this.body) this.body.innerHTML = items.map(function (it) { return itemMarkup(it, false); }).join('');
      this.abrir('agregado');
    }

    /* --- contenido --- */
    pintarCarrito() {
      var self = this;
      return fetchCart().then(function (c) {
        paintCount(c.item_count);
        if (self.countEl) self.countEl.textContent = c.item_count ? '(' + c.item_count + ')' : '';
        // Camisetas primero, y debajo de cada una sus complementos
        var camisetas = c.items.filter(function (it) { return !esComplemento(it); });
        var orden = [];
        camisetas.forEach(function (cam) {
          orden.push(cam);
          c.items.forEach(function (it) { if (esComplemento(it) && it.properties && it.properties['Para la camiseta'] === etiqueta(cam)) orden.push(it); });
        });
        c.items.forEach(function (it) { if (orden.indexOf(it) === -1) orden.push(it); });
        self.lista.innerHTML = orden.map(function (it) { return '<li>' + itemMarkup(it, true) + '</li>'; }).join('');
        self.vacio.hidden = c.item_count > 0;
        self.pagar.toggleAttribute('hidden', c.item_count === 0);
        document.dispatchEvent(new CustomEvent('esc:toast-open')); // esc-ventas: envío gratis + fecha
        return c;
      }).catch(function () {});
    }

    quitar(key, boton) {
      var self = this;
      boton.disabled = true;
      fetchCart().then(function (c) {
        var linea = c.items.filter(function (it) { return it.key === key; })[0];
        var updates = {}; updates[key] = 0;
        if (linea && !esComplemento(linea)) {
          c.items.forEach(function (it) {
            if (esComplemento(it) && it.properties && it.properties['Para la camiseta'] === etiqueta(linea)) updates[it.key] = 0;
          });
        }
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
      }).then(function () { return self.pintarCarrito(); })
        .then(function () { if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload(); });
    }

    /* --- apertura y cierre --- */
    abrir(modo) {
      var agregado = modo === 'agregado';
      this.titulo.textContent = agregado ? 'Agregado al carrito' : 'Tu carrito';
      this.check.hidden = !agregado;
      this.body.hidden = !agregado;
      this.h.hidden = !agregado;
      if (!agregado) this.body.innerHTML = '';
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('esc-cajon-abierto');
      document.addEventListener('keyup', this.onKeyup);
      this.pintarCarrito();
      var cerrar = this.querySelector('.esc-cajon__cerrar');
      setTimeout(function () { if (cerrar) cerrar.focus({ preventScroll: true }); }, 60);
    }
    open() { this.abrir('agregado'); }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('esc-cajon-abierto');
      document.removeEventListener('keyup', this.onKeyup);
      // Devolver el foco a quien abrió el panel
      if (this.activeElement && document.contains(this.activeElement)) {
        try { this.activeElement.focus({ preventScroll: true }); } catch (e) {}
      }
      this.activeElement = null;
    }

    handleKeyup(evt) { if (evt.key === 'Escape') this.close(); }
  }

  customElements.define('cart-notification', CartNotification);

  /* bfcache (atrás/adelante del navegador): el DOM vuelve con un conteo viejo. */
  window.addEventListener('pageshow', function (evt) { if (evt.persisted) refreshCount(); });
})();
